import axios from 'axios'
import swal from 'sweetalert'
import { createApp } from 'vue'

if (document.getElementById('blog')) {
  const app = createApp({
    data() {
      return {
        limit: 6,
        hasMorePosts: true,
        paginationType: window.culligan.paginationType || 'load-more', // "load-more" or "pages"
        posts: window.culligan.blogPosts || [],
        totalPosts: window.culligan.totalBlogPosts || 0,
        queryVars: window.culligan.queryVars || {},

        // Pagination links
        curPageNum: 1,
      }
    },
    computed: {
      offset() {
        return this.posts.length
      },
      featuredPost() {
        if (this.posts.length) {
          return this.posts[0]
        }
      },
      latestPosts() {
        if (this.posts.length > 1) {
          return this.posts.slice(1, 3)
        }
      },
      otherPosts() {

        // "Load More"
        if (this.paginationType == 'load-more') {

          // If there are more than three posts in 
          // total, then show all posts beyond the
          // first three featured/latest posts...
          if (this.posts.length > 3) {
            return this.posts.slice(3)
          }

        // Pagination links
        } else {

          // If we're on page 1 then don't include
          // the featured/latest posts...
          if (this.curPageNum == 1) {
            if (this.posts.length > 3) {
              return this.posts.slice(3)
            }

          // otherwise, if we're not a page 1
          // then show all posts.
          } else {
            return this.posts
          }
        }
      },
      numPages() {
        return Math.ceil(this.totalPosts / this.limit)
      },
    },
    mounted() {
      if (this.posts.length <= this.limit) {
        this.hasMorePosts = false
      }
    },
    methods: {
      /**
       * "Load More Posts"
       */
      loadMoreBlogPosts(e) {
        let button = e.target
        let buttonText = button.textContent || button.innerText
        button.disabled = true
        button.textContent = 'Loading...'

        const params = new URLSearchParams()
        params.append('action', 'load_blog_posts')
        params.append('offset', this.offset)
        params.append('limit', this.limit)
        params.append('query', JSON.stringify(this.queryVars))

        axios.post(ajaxurl, params)
          .then((response) => {
            if (response.data.posts) {
              let posts = JSON.parse(response.data.posts)
              if (posts.length) {
                this.posts = this.posts.concat(posts)
              } else {
                this.hasMorePosts = false
              }
            }
          })
          .catch(() => {
            swal('', 'An unexpected error occurred.', 'error')
          })
          .then(() => {
            button.disabled = false
            button.textContent = buttonText
          })
      },
      /**
       * Load blog posts for a page number.
       */
      loadBlogPostsForPage(pageNum) {
        // Include the 1 featured post and 2 recent posts
        // on page 1 (so + 3).
        const limit = (pageNum == 1) ? (this.limit + 3) : this.limit

        // Include the 1 featured post and 2 recent posts
        // on page 1 (so + 3).
        let offset = limit * (pageNum - 1)
        if (pageNum > 1) {
          offset += 3
        }

        const params = new URLSearchParams()
        params.append('action', 'load_blog_posts')
        params.append('offset', offset)
        params.append('limit', limit)
        params.append('query', JSON.stringify(this.queryVars))

        axios.post(ajaxurl, params)
          .then((response) => {
            if (response.data.posts) {
              let posts = JSON.parse(response.data.posts)
              if (posts.length) {
                this.posts = posts
                this.curPageNum = pageNum

                // Scroll back to the top of the page.
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth',
                })
              }
            }
          })
          .catch(() => {
            swal('', 'An unexpected error occurred.', 'error')
          })
      },
    }
  })

  app.mount('#blog')
}
